<template>
  <tooltip :target="target" :placement="placement" boundary="window">
    <div class="d-flex align-self-center">
      {{ text }}
      <span class="tooltip-tab" v-for="(action, index) in actions" :key="index">{{ action }}</span>
    </div>
  </tooltip>
</template>

<script>
import Tooltip from '@/components/Tooltip'

/**
 * This component can be used to show tooltips, with keyboard shortcut indicator
 */
export default {
  name: 'actionTooltip',
  props: {
    /**
     * id of the element on hover of which tooltip should be shown
     */
    target: {
      type: String
    },
    /**
     * text inside tooltip
     */
    text: {
      type: String
    },
    /**
     * can be used to highlight few actions in the tooltip (like keyboard shortcut)
     */
    actions: { type: Array, default: () => [] },
    /**
     * Bootstrap tooltip placements
     */
    placement: String
  },
  components: {
    Tooltip
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.tooltip-tab {
  background: $documentColor;
  min-width: 17px;
  height: 17px;
  display: block;
  color: $primary;
  border-radius: 3px;
  margin-left: 6px;
  padding: 0 3px;
}
</style>
